// extracted by mini-css-extract-plugin
export default {"content":"tooltip_content__AFp+w","opened":"tooltip_opened__7KogQ","arrow":"tooltip_arrow__zREmX"};